import config from '../config'
import moment from 'moment'

const BASE_URL = config.api.url

const request = async (url, params, controller) => {
  const token = localStorage.getItem('token')
  if (params) {
    url += '?'
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null) {
        return
      }
      if (Array.isArray(value)) {
        value.forEach((item) => {
          url += `${key}=${encodeURIComponent(item)}&`
        })
        return
      }
      url += `${key}=${encodeURIComponent(value)}&`
    })
  }
  const response = fetch(
    `${BASE_URL}/company/${url}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? {Authorization: `Bearer ${token}`} : null),
      },
      signal: controller.signal,
    }
  )
  return response
}

export const getRanges = (from, to) => {
  const parsed = {
    from: moment(from.format('YYYY-MM-DD')),
    to: moment(to.format('YYYY-MM-DD')),
  }
  const current = {
    from: parsed.from,
    to: parsed.to.add(1, 'days'),
  }
  const diff = current.to.diff(current.from, 'days')
  const previous = {
    from: current.from.clone().subtract(diff, 'days').format('YYYY-MM-DD'),
    to: current.to.clone().subtract(diff, 'days').format('YYYY-MM-DD'),
  }
  return {
    current: {
      from: current.from.format('YYYY-MM-DD'),
      to: current.to.format('YYYY-MM-DD'),
    },
    previous: previous,
    diff: diff,
  }
}

export const useIiko = (companyId) => {
  const makeRequest = (url, params) => {
    const controller = new AbortController()
    const send = async () => {
      const fullUrl = `${companyId}/iiko/${url}`
      const response = await request(fullUrl, params, controller)
      if (response.ok) {
        return await response.json()
      }
      return response
    }
    return {
      send: send,
      cancel: () => controller.abort('Request cancelled'),
    }
  }

  return makeRequest
}